import { cn, Switch } from '@wellesley/ui'
import { FC, ReactNode } from 'react'
import CustomTooltip from '../CustomTooltip'

type CmpProps = {
  checked: boolean
  leftLabelText?: string
  labelText?: string
  onChange: (value: boolean) => void
  className?: string
  name?: string
  disabled?: boolean
  autoFocus?: boolean
  tooltipText?: ReactNode
}

const SwitchWithLabel: FC<CmpProps> = ({
  checked,
  name,
  leftLabelText,
  labelText,
  onChange,
  className,
  disabled = false,
  autoFocus = false,
  tooltipText,
}) => {
  const switchComponent = (
    <label
      className={cn(
        'gap-xxs mb-[6px] flex w-full cursor-pointer flex-row-reverse items-center justify-between text-base font-medium text-gray-700 md:w-fit md:flex-row md:justify-normal',
        className,
      )}
    >
      {leftLabelText && <span>{leftLabelText}</span>}
      <Switch
        checked={checked}
        disabled={disabled}
        name={name}
        onCheckedChange={onChange}
        autoFocus={autoFocus}
      />
      {labelText && <span>{labelText}</span>}
    </label>
  )

  if (tooltipText) {
    return (
      <div className="w-full [&>div]:w-full">
        <CustomTooltip
          tooltipText={tooltipText}
          triggerProps={{
            className: 'w-full',
          }}
          contentProps={{
            side: 'bottom',
            align: 'start',
          }}
        >
          {switchComponent}
        </CustomTooltip>
      </div>
    )
  }

  return switchComponent
}

export default SwitchWithLabel
